"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
exports.findVariables = function (string) {
    return ramda_1.pipe(ramda_1.match(new RegExp("\\{\\s*variables\\.([a-zA-Z]+)\\s*\\}", 'g')), ramda_1.map(ramda_1.replace(/[\s{}]/g, '')), ramda_1.map(ramda_1.replace(/variables\./g, '')))(string);
};
//# sourceMappingURL=find-variables.js.map